<template>
    <UButton v-bind="$attrs" :to="to" :block="block" variant="ghost"
        class="mt-auto font-bold py-3 px-6 transition-all bg-transparent border border-gray-200 text-gray-700 hover:bg-transparent hover:border-gray-400 hover:text-gray-700 active:bg-transparent active:border-gray-400 active:text-gray-700"
        :ui="{ rounded: 'rounded-md' }">
        <slot />
    </UButton>
</template>

<script setup>
defineProps({
    to: {
        type: String,
        default: undefined
    },
    block: {
        type: Boolean,
        default: true
    }
})
</script>